module.exports = __webpack_public_path__ + "static/media/digiBackward.f3107d2e.svg";